import React from 'react'
import styled from 'styled-components'
import FooterLinks from './components/FooterLinks'
import MobileLogos from './components/MobileLogos'

const Wrapper = styled.div`
  background-color: rgba(240, 240, 240, 1);
  padding: 0 16px;
`

function MobileFooter(props) {
  return (
    <Wrapper>
      <FooterLinks isMobile={true} />
      <MobileLogos />
    </Wrapper>
  )
}

export default MobileFooter



// WEBPACK FOOTER //
// ./src/organisms/Footer/MobileFooter.js